import React from 'react';
import styled from 'styled-components';

const Arrow = styled.div<{ direction: 'left' | 'right' }>`
  width: 0;
  height: 0;
  border-style: solid;
  cursor: pointer;

  ${({ direction }) =>
    direction === 'left'
      ? `
    border-width: 10px 14px 10px 0;
    border-color: transparent #0000FF transparent transparent;
  `
      : `
    border-width: 10px 0 10px 14px;
    border-color: transparent transparent transparent #0000FF;
  `}

  position: absolute;
  top: 50%;
  z-index: 2;
  transform: translateY(-50%);
  ${(props) => (props.direction === 'left' ? 'left: -25px;' : 'right: -25px;')}
`;

export const PrevArrow = (props: any) => {
  const { onClick, currentSlide } = props;
  if (currentSlide === 0) return null;

  return <Arrow direction="left" onClick={onClick} />;
};

export const NextArrow = (props: any) => {
  const { onClick, currentSlide, slideCount } = props;
  if (currentSlide === slideCount - 1) return null;

  return <Arrow direction="right" onClick={onClick} />;
};
